export const SCRIBE_ROUTE = '/scribe';

export interface LiveScribeRouteOptions {
  state?: Record<string, unknown> | null;
  patient?: unknown;
  continueEncounterId?: string | null;
}

export const buildLiveScribeRouteState = (
  options: LiveScribeRouteOptions = {},
): Record<string, unknown> => {
  const state = options.state || {};
  const hasPatient =
    Object.prototype.hasOwnProperty.call(options, 'patient') ||
    Object.prototype.hasOwnProperty.call(state, 'patient');
  const patient = Object.prototype.hasOwnProperty.call(options, 'patient')
    ? options.patient
    : state.patient;
  const continueEncounterId = Object.prototype.hasOwnProperty.call(
    options,
    'continueEncounterId',
  )
    ? options.continueEncounterId
    : state.continueEncounterId;

  return {
    ...state,
    ...(hasPatient ? {patient: patient || null} : {}),
    ...(continueEncounterId ? {continueEncounterId} : {}),
    autoStart: true,
  };
};
